import { usePut } from '../../../sharedModules/hooks/useQuery';

interface UpdateCollectionClientParams {
  id: number;
  collectionEnabled: boolean;
}

interface UpdateCollectionClientResponse {
  id: number;
  location: string;
  acct_no: string;
  collection_enabled: boolean;
}

export function useUpdateCollectionClient() {
  const mutation = usePut<UpdateCollectionClientResponse>();

  const updateClient = ({ id, collectionEnabled }: UpdateCollectionClientParams) =>
    mutation.mutateAsync({
      url: `/collections/clients/${id}`,
      data: { client: { collection_enabled: collectionEnabled } },
    });

  return {
    updateClient,
    isLoading: mutation.isPending,
    isError: mutation.isError,
  };
}
